import { Injectable } from '@angular/core';
import { LogLevel } from '@dxp/core/types';
import { environment } from '@dxp/core/environment';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    isEnabled = environment.isLoggingEnabled;

    verbose(message?: any, ...optionalParams: any[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Verbose) {
            if (optionalParams.length > 0) console.log(message, optionalParams);
            else console.log(message);
        }
    }

    debug(message?: any, ...optionalParams: any[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Debug) {
            if (optionalParams.length > 0) console.log(message, optionalParams);
            else console.log(message);
        }
    }

    error(message?: any, ...optionalParams: any[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Error) {
            if (optionalParams.length > 0)
                console.error(message, optionalParams);
            else console.error(message);
        }
    }

    warn(message?: any, ...optionalParams: any[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Warning) {
            if (optionalParams.length > 0)
                console.warn(message, optionalParams);
            else console.warn(message);
        }
    }

    info(message?: any, ...optionalParams: any[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Information) {
            if (optionalParams.length > 0)
                console.info(message, optionalParams);
            else console.info(message);
        }
    }

    table(tabularData?: any, properties?: string[]) {
        if (this.isEnabled && environment.logLevel <= LogLevel.Verbose) {
            console.table(tabularData, properties);
        }
    }
}
